import React from 'react';
import {
  Dialog,
  DialogContent,
  DialogActions,
  Typography,
} from '@material-ui/core';
import { navigate } from '@reach/router';
import routes from '../../../../routes';
import { useTranslation } from '../../../../hooks/useTranslation';
import PGEButton from '../../../buttons';

interface SignInModalProps {
  open: boolean;
  onClose: () => void;
}

const SignInForSiteVisitModal: React.FC<SignInModalProps> = ({
  open,
  onClose,
}) => {
  const { t, inlineRichT } = useTranslation();
  return (
    <Dialog open={open} onClose={onClose} maxWidth="xs" fullWidth>
      <DialogContent>
        <Typography variant="body1" align="center">
          {inlineRichT('SIGN_IN_FOR_SITE_VISIT_CONSULTATION')}
        </Typography>
      </DialogContent>

      <DialogActions style={{ justifyContent: 'center', paddingBottom: 24 }}>
        <PGEButton variant="outlined" color="primary" onClick={onClose}>
          {t('CANCEL')}
        </PGEButton>
        <PGEButton
          variant="contained"
          color="primary"
          onClick={() =>
            (window.parent.location.href = routes.ENERGY_CONSULTATION_FORM)
          }
        >
          {t('SIGN_IN')}
        </PGEButton>
      </DialogActions>
    </Dialog>
  );
};

export default SignInForSiteVisitModal;
